function loadMoreProducts() {
    const loadMoreBtns = document.querySelectorAll('.crowd-pleasers_load-more');
    loadMoreBtns?.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const hiddenProducts = e.target.closest('.crowd-pleasers_inner').querySelectorAll('.crowd-pleasers-layout_grid .crowd-pleasers_product.hidden');
            for(let i=0;i<8;i++) {
                if(hiddenProducts[i]) {
                    hiddenProducts[i].classList.remove('hidden');
                    const remainingProducts = e.target.closest('.crowd-pleasers_inner').querySelectorAll('.crowd-pleasers-layout_grid .crowd-pleasers_product.hidden');
                    if(remainingProducts.length === 0) e.target.remove();
                }
            }
        })
    })
}

document.addEventListener('DOMContentLoaded', loadMoreProducts)